import { FusePageSimple } from '@fuse';
import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';

import {
    Button,
    Radio,
    Table, TableBody, TableCell, TableHead,
    TableRow,
    TextField,
    Typography
} from 'material-ui';
//import Table from '@material-ui/core/Table';
/* import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel'; */




import axios from 'axios/index';

import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import RSelect from 'react-select';


const styles = theme => ({
    layoutRoot: {},
    tablehead: {
        fontSize: '16px',
        fontWeight: '500',
        color: 'rgba(0, 0, 0, 1)'
    },
    tablecell: {
        fontSize: '15px',
        fontWeight: '500',
        color: 'rgba(63, 63, 63, 0.842)'
    },
    smaller: {
        height: '20px',
    }
});


class UnitConversion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            unitCategory: 'Select category',
            unitCategories: [],
            unitCategory2: '',
            unitCategories2: [],
            selectedValue: '',
            unitTypes: [],
            loading: true
        };

        this.handleUpdateButtonClick = this.handleUpdateButtonClick.bind(this);
        this.handleResetButtonClick = this.handleResetButtonClick.bind(this);
        this.showNoResults = this.showNoResults.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);

        this.updateCategories();
    }

    showNoResults() {
        return
        <div>
            test
        </div>
            ;
        /* if(this.state.unitTypes.length==0){
            return (
                <div>

                </div>
            );
        }
        else{
            return (
                <div align="center">
                    <strong>No records</strong>
                </div>
            );
        } */
    }

    handleRadioChange = event => {
        this.setState({ selectedValue: event.target.value })
        var newState = this.state.unitTypes.slice();

        //console.log('handleRadioChange',event.target.value );

        for (let i = 0; i < newState.length; i++) {
            if (newState[i].name === event.target.value) {
                newState[i].baseUnit = true;
                //newState[i].oldRate = newState[i].rate;
                newState[i].rate = "1";
            }
            else {
                newState[i].rate = "0";
                newState[i].baseUnit = false;
            }

        }
        //newState[event.target.value].baseUnit = true;
        console.log('newState', newState);
        this.setState({ unitTypes: newState });
    };

    handleTextChange = (event) => {
        //this.setState({ selectedValue: event.target.value })

        var newState = this.state.unitTypes.slice();

        for (let i = 0; i < newState.length; i++) {
            if (newState[i].name === event.target.id) {
                newState[i].rate = event.target.value;
                break;
            }
        }

        //console.log('onTextChangeNewState', newState);

        this.setState({ unitTypes: newState });
    };

    handleUpdateButtonClick() {
        console.log('before updating', this.state.unitTypes);

        for (let i = 0; i < this.state.unitTypes.length; i++) {
            if (this.state.unitTypes[i].rate == '' || isNaN(this.state.unitTypes[i].rate)) {
                return this.props.alert.error('Invaldid data');
            }
        }

        this.setState({ loading: true });

        let req = {
            unitCategory: this.state.unitCategory2,
            unitTypes: this.state.unitTypes
        }

        var url = window.systemServer + "/system/bulkUpdateUnitTypeRatesAndBaseUnit";

        const request = axios.post(url, req);

        request.then((response) => {


            if (!response.data.error) {
                console.log('bulk update success');
                this.props.alert.success('Change successful');
                this.getUnitTypes(this.state.unitCategory2);
            }
            else {
                console.log('error', response.data.error);
                this.props.alert.success('Change unsuccessful');
            }
        })
            .catch((error) => {

                //this.handleClose();
                // Error
                if (error && typeof error === 'undefined') {
                    console.log('login axios error block', error);
                    this.props.alert.success('Error');
                }
                else if (error) {
                    console.log('error');
                    this.props.alert.success('Error');
                }
            });


    }

    handleResetButtonClick() {
        this.getUnitTypes(this.state.unitCategory2);
    }


    /* handleChange = event => {
        this.setState({ unitCategory: event.target.value });

        this.getUnitTypes(event.target.value);
    }; */

    getUnitTypes(categoryName) {

        this.setState({ loading: true });
        this.setState({ selectedValue: '' });

        let req = {
            unit_catagory_name: categoryName
        }

        var url = window.systemServer + "/system/getUnitTypeByCatagoryName";

        const request = axios.post(url, req);
        request.then((response) => {
            if (!response.data.error) {
                if (window.DATABASE_TYPE == "MYSQL") {
                    var unitTypes = response.data.result;
                    for (let i = 0; i < unitTypes.length; i++) {
                        if (unitTypes[i].baseUnit) {
                            this.setState({ selectedValue: unitTypes[i].name });
                            break;
                        }
                    }
                    this.setState({ unitTypes: unitTypes });
                    this.setState({ loading: false });
                } else {
                    var unitTypes = response.data[0].unit_type;
                    for (let i = 0; i < unitTypes.length; i++) {
                        if (unitTypes[i].baseUnit) {
                            this.setState({ selectedValue: unitTypes[i].name });
                            break;
                        }
                    }
                    this.setState({ unitTypes: unitTypes });
                    this.setState({ loading: false });
                }
            }
            else {
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                if (error && typeof error === 'undefined') {
                    console.log('login axios error block', error);
                }
                else if (error) {
                    console.log('error');
                }
                this.setState({ loading: false });
            });
    }

    updateCategories() {
        this.setState({ loading: true });
        const request = axios.get(window.systemServer + '/system/loadActiveUnitCatagory');
        request.then((response) => {

            if (!response.data.error) {
                let unitCategories = [];
                let unitCategories2 = [];
                if (Array.isArray(response.data.result)) {
                    unitCategories = response.data.result.map(item => item.unit_catagory_name);
                    response.data.result.map(item => {
                        let t = { value: item.unit_catagory_name, label: item.unit_catagory_name };
                        unitCategories2.push(t);
                    });
                } else {
                    console.error("response.data is not an array.");
                    // Handle the error or provide a default value for unitCategories and unitCategories2
                }

                this.setState({ unitCategories2: unitCategories2 });
                this.setState({ unitCategory: unitCategories.slice()[0] });
                //this.getUnitTypes(unitCategories[0]);
                this.setState({ loading: false });

            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });

    }


    updateUnits() {

    }

    handleFocus(event) {
        event.stopPropagation();
        if (event.target.value == 0) {
            var newState = this.state.unitTypes.slice();

            for (let i = 0; i < newState.length; i++) {
                if (newState[i].name === event.target.id) {
                    newState[i].rate = '';
                    break;
                }
            }

            this.setState({ unitTypes: newState });

        }
    }

    handleBlur(event) {
        event.stopPropagation();
        if (event.target.value == '') {
            var newState = this.state.unitTypes.slice();

            for (let i = 0; i < newState.length; i++) {
                if (newState[i].name === event.target.id) {
                    newState[i].rate = '0';
                    break;
                }
            }

            this.setState({ unitTypes: newState });

        }
    }



    componentWillMount() {
        this.updateCategories();
    }

    handleUnitCategoryChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({ unitCategory2: selectedOption.value });
            this.getUnitTypes(selectedOption.value);
        }
        else {
            this.setState({ unitCategory2: '' });

        }
    }

    render() {
        const { classes } = this.props;

        const { canSubmit, canSubmit2 } = this.state;
        if (this.state.loading) {
            return (


                <Loader />

            );
        }
        else {

            return (
                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot
                    }}
                    content={
                        <div className="p-40">
                            <div>
                                <Typography className="h2 mb-24 subtitle-color">Unit Conversion</Typography>


                                {/* <Select
                                value={this.state.unitCategory}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'selUnitCategory',
                                    id: 'selUnitCategory',
                                }}
                            >

                                {this.state.unitCategories.map(function (item, i) {
                                    return <MenuItem value={item}>{item}</MenuItem>;
                                })}

                            </Select> */}

                                <div className="md:w-1/5 block">
                                    <RSelect
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Unit Category"
                                        value={this.state.unitCategory2}
                                        onChange={this.handleUnitCategoryChange}
                                        options={this.state.unitCategories2}
                                    />
                                </div>



                            </div>

                            {this.state.unitTypes.length == 0 ?

                                <div className="bg-green-lighter w-full mt-8 p-8" align="center">{this.state.unitCategory2 != '' ? 'No unit types found' : 'Select a unit category'}</div>


                                : <div>

                                    <div>
                                        <Table className={classes.table}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={classes.tablehead}>Unit Type</TableCell>
                                                    <TableCell className={classes.tablehead} numeric>Base Unit</TableCell>
                                                    <TableCell className={classes.tablehead} numeric>Rate</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>

                                                {this.state.unitTypes.map(n => {
                                                    return (
                                                        <TableRow className="p-0 m-0 h-20" key={n._id}>
                                                            <TableCell className={classes.tablecell} component="th" scope="row">
                                                                {n.name}
                                                            </TableCell>
                                                            <TableCell className={classes.tablecell} numeric>

                                                                <Radio
                                                                    checked={this.state.selectedValue === n.name}
                                                                    onChange={this.handleRadioChange}
                                                                    value={n.name}
                                                                    name="radioBaseUnit"
                                                                    aria-label="A"
                                                                    color="default"
                                                                />

                                                            </TableCell>
                                                            <TableCell className={classes.tablecell} numeric>

                                                                <TextField
                                                                    id={n.name}
                                                                    ref={n.name}
                                                                    className={classes.textField}
                                                                    margin="normal"
                                                                    disabled={n.baseUnit}
                                                                    value={n.rate}
                                                                    onChange={this.handleTextChange}
                                                                    onFocus={this.handleFocus}
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </div>

                                    {/*                         <div>
                            test1
                        {this.showNoResults()}
                        </div> */}


                                    <div className="py-12 float-right">
                                        <div className="mx-8 inline-block"><Button onClick={this.handleResetButtonClick} color="primary" variant="raised" className="">Reset</Button></div>
                                        <div className="mx-8 inline-block"><Button onClick={this.handleUpdateButtonClick} color="secondary" variant="raised" className="">Update</Button></div>
                                    </div>
                                </div>

                            }

                        </div>

                    }
                />
            )
        }
    }
}



export default withStyles(styles, { withTheme: true })(withAlert(UnitConversion));


// WEBPACK FOOTER //
// ./src/main/content/system/unit-conversion/UnitConversion.js